import QuizActions from '../actions/quizActions';
import axios from 'axios';
import Path from '../../config/path';

const httpClientDelete = axios.create();
httpClientDelete.defaults.timeout = 5000;

const httpClientResult = axios.create();
httpClientResult.defaults.timeout = 10000;

class QuizMiddleware {

    static verifyProctoringKeyMiddleware(data) {
        // console.log(data)
        return dispatch => {
            axios.post(`${Path.QUIZ}/course/${data.courseId}/quiz/${data.quizId}/verifyProctoringKey?quizId=${data.quizId}`, {
                proctoringKey : data.proctoringKey,
                isRegister : true
            }).then((response) => {
                // console.log(response.data.data)
                if(response.data.data === null) {
                    dispatch(QuizActions.ErrorInProctorKey(response.data))
                }
                else{
                dispatch(QuizActions.ProctorKey(response.data.data))
                }
            }).catch((err) =>  { 
                // console.log(err)
                dispatch(QuizActions.NetworkErrorInProctorKey(err))
            })
        }
    }

    static deleteAnswerSheetMiddleware(data) {
        // console.log(data)
        return dispatch => {
            httpClientDelete.delete(`${Path.UPDATE}${data.userId}/answersheet/${data.answerSheetId}?answersheetId=${data.answerSheetId}`, {
                data : {
                    isRegister: true
                },
            }).then((response) => {
                // console.log(response)
                dispatch(QuizActions.DeleteAnswerSheet(response.data.data))
            }).catch((err) =>  { 
                // console.log(err)
                dispatch(QuizActions.DeleteAnswerSheetFailed(err))
            })
        }
    }

    static startQuizMiddleware(data) {
        // console.log(data)
        return dispatch => {
            axios.post(`${Path.QUIZ}/user/${data.userId}/course/${data.courseId}/quiz/${data.quizId}/class/${data.classId}/startquiz?quizId=${data.quizId}&classId=${data.classId}&courseId=${data.courseId}&userId=${data.userId}`, {
                additionalFieldsWithValue :data.additionalFields,
                pc_access_token : data.pc_access_token,
                isRegister : true
            }).then((response) => {
                // console.log(response)
                dispatch(QuizActions.StartQuiz(response.data.data))
            }).catch((err) => {
            // console.log(err)
            dispatch(QuizActions.ErrorInQuizStart(err))
            })
        }
    }

    static continueQuizMiddleware(data) {
        // console.log(data)
        return dispatch => {
            axios.post(`${Path.QUIZ}/continueQuiz/${new Date().getTime()}`,{
                answerSheetId : data.answerSheetId,
                pc_access_token : data.pc_access_token,
                isRegister : true
            }).then((response) => {
                // console.log(response)
                if (response.data.Error) {
                    dispatch(QuizActions.ErrorInContinueQuiz(response.data))
                }
                else {
                    dispatch(QuizActions.ContinueQuiz(response.data))
                }
            }).catch((err) => {
                console.log(err)
            })
        }
    }

    static submitAnswerMiddleware(data) {
        // console.log(data)
        return dispatch => {
            switch(data.answerType){
                case "TrueFalseAnswer" : {
                    axios.post(`${Path.QUIZ}/course/${data.courseId}/quiz/${data.quizId}/answer/${data.answerSheetId}/${data.questionId}/quiztaker?answerSheetId=${data.answerSheetId}&questionId=${data.questionId}`, {
                        _type : data.answerType,
                        selectedAnswer : data.answer,
                        isSingleSelect : data.isSingleSelect,
                        timeConsumed : data.timeConsumed,
                        quizTime : data.quizTime,
                        isRegister : true
                    }).then((response) => {
                        // console.log(response.data)
                        dispatch(QuizActions.SubmitAnswer(response.data))
                    }).catch(err => { 
                    // console.log(err)
                    })
                    break;
                }
                case "MCQAnswer" : {
                    axios.post(`${Path.QUIZ}/course/${data.courseId}/quiz/${data.quizId}/answer/${data.answerSheetId}/${data.questionId}/quiztaker?answerSheetId=${data.answerSheetId}&questionId=${data.questionId}`, {
                        _type : data.answerType,
                        isSingleSelect : data.isSingleSelect,
                        choices : data.answerChoices,
                        timeConsumed : data.timeConsumed,
                        quizTime : data.quizTime,
                        isRegister : true
                    }).then((response) => {
                        // console.log(response.data)
                        dispatch(QuizActions.SubmitAnswer(response.data))
                    }).catch(err => { 
                    // console.log(err)
                    })
                    break;
                }
            }
        }
    }

    static showResultMiddleware(data) {
        // console.log(data)
        return dispatch => {
            httpClientResult.get(`${Path.QUIZ}/${data.answerSheetId}/generateresult/${data.showResultToStudents}?answerSheetId=${data.answerSheetId}&showResultToStudents=${true}`, {
                headers : {
                    "Content-Type":"application/json",
                    "pc_access_token":`${data.pc_access_token}`,
                    "userId":`${data.userId}`,
                    "isTimeUp" : `${data.isTimeUp}`,
                    'timeConsumed' : `${data.timeConsumed}`
                    }
            }).then((response) => {
                // console.log(response)
                // alert(response)
                dispatch(QuizActions.ShowResultSuccess(response.data.data))
            }).catch((err) => {
                // console.log(err)
                // alert(err)
                dispatch(QuizActions.ShowResultFailed(err))
            })
        } 
    }
}

export default QuizMiddleware;


// WEBPACK FOOTER //
// ./src/store/middleware/quizMiddleware.js